import React from 'react';

const cls = 'btn primary bg-indigo-700 text-white py-3 px-5 rounded';

const ButtonSelector = ({
  onClick,
  text = '',
}) => {
  return (
    <>
      <button className={cls} onClick={onClick} style={{
        width: 'fit-content',
        padding: '0px 1rem',
      }}>
        {text} <span className='arrow down'></span>
      </button>
      <style jsx global>
        {`
        .arrow {
          border: solid #fff;
          border-width: 0 3px 3px 0;
          display: inline-block;
          padding: 3px;
          margin-left: 8px;
        }
        
        .down {
          transform: rotate(45deg);
          -webkit-transform: rotate(45deg);
        }
      `}
      </style>
    </>
  )
};

export default ButtonSelector;